module.exports = {"TXTCLI_Select_All":{"id":"TXTCLI_Select_All","defaultMessage":"Επιλογή Όλων","track":"Select All"}}